import { Component } from '@angular/core';

@Component({
  selector: 'app-notificaciones-cliente',
  templateUrl: './notificaciones-cliente.component.html',
  styleUrls: ['./notificaciones-cliente.component.css']
})
export class NotificacionesClienteComponent {

}
